<div class="content-loaf">
    <h2>お知らせ</h2>
  <hr />

  <div class="content-block">
    <div class="col-12 iframe-scroll">
      <iframe src="/MembersNews/news.php" frameborder="0"></iframe>
    </div>
  </div>
</div>
